// The brand this build runs as (brands/<BRAND>/brand.js, chosen at build time).
import config from '@brand/brand.js'

// A build for another domain than the brand's own (e.g. a dev server) sets VITE_SITE_URL;
// it doesn't report to the live shop's Sentry project
const brand = import.meta.env.VITE_SITE_URL
  ? { ...config, siteUrl: import.meta.env.VITE_SITE_URL, sentry: { ...config.sentry, dsn: null } }
  : config

export default brand

/** Is a brand-specific feature (brand.features) enabled? */
export const hasFeature = (name) => brand.features?.[name] === true

/** Path of an info page, e.g. pagePath('contact') -> '/papricka/contact' */
export const pagePath = (page = '') => (page ? `${brand.pagesPath}/${page}` : brand.pagesPath)

/** Link to the brand phone, e.g. phoneLink() -> 'tel:+421...', phoneLink('sms') */
export const phoneLink = (scheme = 'tel') => `${scheme}:${brand.contact.phone.replace(/\s+/g, '')}`

/** Drop routes (recursively) whose meta.feature is disabled for this brand */
export const filterRoutesByFeature = (routes) =>
  routes
    .filter((route) => !route.meta?.feature || hasFeature(route.meta.feature))
    .map((route) => (route.children ? { ...route, children: filterRoutesByFeature(route.children) } : route))

/** Vue plugin: $brand, $hasFeature(), $pagePath() and $phoneLink() in templates */
export const brandPlugin = {
  install(app) {
    app.config.globalProperties.$brand = brand
    app.config.globalProperties.$hasFeature = hasFeature
    app.config.globalProperties.$pagePath = pagePath
    app.config.globalProperties.$phoneLink = phoneLink
  },
}
